import validate from "/Users/jflowerhome/devProjects/uwit/node_modules/.pnpm/nuxt@3.11.2_@unocss+reset@0.59.0_eslint@8.57.0_floating-vue@5.2.2_typescript@5.4.5_unocss@0.59.0_vite@5.2.8/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/jflowerhome/devProjects/uwit/node_modules/.pnpm/nuxt@3.11.2_@unocss+reset@0.59.0_eslint@8.57.0_floating-vue@5.2.2_typescript@5.4.5_unocss@0.59.0_vite@5.2.8/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}